import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, ListGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useNavigate } from "react-router-dom";

const Cart = ({ cartItems }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    country: 'India',
    streetAddress: '',
    apartment: '',
    town: '',
    state: '',
    postcode: '',
    phone: '',
    email: '',
    createAccount: false,
  });

  const [isFormValid, setIsFormValid] = useState(false);

  const cityOptions = [
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Ahmedabad', label: 'Ahmedabad' },
    { value: 'Surat', label: 'Surat' },
    { value: 'Jaipur', label: 'Jaipur' },
    { value: 'Lucknow', label: 'Lucknow' },
    { value: 'Kanpur', label: 'Kanpur' },
    { value: 'Indore', label: 'Indore' },
    { value: 'Nagpur', label: 'Nagpur' },
    { value: 'Chandigarh', label: 'Chandigarh' },
    { value: 'Vadodara', label: 'Vadodara' },
    { value: 'Coimbatore', label: 'Coimbatore' },
    { value: 'Patna', label: 'Patna' },
    { value: 'Bhopal', label: 'Bhopal' },
    { value: 'Mysore', label: 'Mysore' },
    { value: 'Visakhapatnam', label: 'Visakhapatnam' },
    { value: 'Madurai', label: 'Madurai' },
    { value: 'Nashik', label: 'Nashik' },
    { value: 'Faridabad', label: 'Faridabad' },
    { value: 'Ludhiana', label: 'Ludhiana' },
    { value: 'Rajkot', label: 'Rajkot' },
    { value: 'Gurugram', label: 'Gurugram' },
  ];  
  const validateForm = () => {
    const { firstName, lastName, streetAddress, town, state, postcode, phone, email } = formData;
    const isValid = firstName && lastName && streetAddress && town && state && postcode && phone && email;
    setIsFormValid(isValid);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: type === 'checkbox' ? checked : value };
      validateForm(updatedData); // Re-validate on each change
      return updatedData;
    });
  };

  // Handle select input change (for Town/City dropdown)
  const handleCityChange = (selectedOption) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, town: selectedOption.value };
      validateForm(updatedData); // Re-validate on city change
      return updatedData;
    });
  };

  const handleProceedToPayment = () => {
    navigate('/payment', {
      state: { cartItems, formData }, // Pass cartItems and formData to payment page
    });
  };

  // Calculate total cost
  const totalCost = cartItems.reduce((total, item) => {
    const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ""));
    return total + (isNaN(price) ? 0 : price);
  }, 0).toFixed(2);

  return (
    <Container className="mt-5">
      <Row>
        {/* Billing Details Form - Left Side */}
        <Col md={6}>
          <h3>Billing Details</h3>
          <Form>
            {/* First Name */}
            <Form.Group className="mb-3" controlId="formFirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter your first name" 
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Last Name */}
            <Form.Group className="mb-3" controlId="formLastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter your last name" 
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Country/Region */}
            <Form.Group className="mb-3" controlId="formCountry">
              <Form.Label>Country / Region</Form.Label>
              <Form.Control 
                type="text" 
                value={formData.country}
                readOnly
              />
            </Form.Group>

            {/* Street Address */}
            <Form.Group className="mb-3" controlId="formStreetAddress">
              <Form.Label>Street address</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter street address" 
                name="streetAddress"
                value={formData.streetAddress}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Apartment, Suite, Unit (Optional) */}
            <Form.Group className="mb-3" controlId="formApartment">
              <Form.Label>Apartment, Suite, Unit, etc. (optional)</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter apartment details" 
                name="apartment"
                value={formData.apartment}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Town / City */}
            <Form.Group className="mb-3" controlId="formTown">
              <Form.Label>Town / City</Form.Label>
              <Select
                options={cityOptions}
                name="town"
                value={cityOptions.find(option => option.value === formData.town)}
                onChange={handleCityChange}
              />
            </Form.Group>

            {/* State */}
            <Form.Group className="mb-3" controlId="formState">
              <Form.Label>State</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter state" 
                name="state"
                value={formData.state}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Postcode / ZIP */}
            <Form.Group className="mb-3" controlId="formPostcode">
              <Form.Label>Postcode / ZIP</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter postcode" 
                name="postcode"
                value={formData.postcode}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Phone Number */}
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter phone number" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Email Address */}
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                type="email" 
                placeholder="Enter email address" 
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Create an Account Checkbox */}
            <Form.Group className="mb-3" controlId="formCreateAccount">
              <Form.Check 
                type="checkbox" 
                label="Create an account?" 
                name="createAccount"
                checked={formData.createAccount}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Col>

        {/* Order Summary - Right Side */}
        <Col md={6}>
          <h3>Order Summary</h3>
          <ListGroup>
            {cartItems.map((item, index) => (
              <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                <div>
                  <img src={item.img} alt={item.name} style={{ width: 50, height: 50, objectFit: 'cover' }} />
                  <span className="ms-3">{item.name}</span>
                </div>
                <span>{item.price}</span>
              </ListGroup.Item>
            ))}
            <ListGroup.Item className="d-flex justify-content-between align-items-center">
              <strong>Total</strong>
              <strong>₹{totalCost}</strong>
            </ListGroup.Item>
          </ListGroup>

          <Button 
            variant="success" 
            className="mt-4 w-100" 
            onClick={handleProceedToPayment} 
            disabled={!isFormValid} // Disable the button if form is not valid
          >
            Proceed to Payment
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Cart;
